import { Node, mergeAttributes } from "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    fileAttachment: {
      setFileAttachment: (options: {
        src: string;
        filename: string;
        filesize: string;
        filetype: string;
      }) => ReturnType;
    };
  }
}

export const FileAttachment = Node.create({
  name: "fileAttachment",

  group: "block",

  atom: true,

  addAttributes() {
    return {
      src: {
        default: null,
        parseHTML: (element) =>
          element.querySelector("a")?.getAttribute("href"),
      },
      filename: {
        default: "file",
        parseHTML: (element) =>
          element.querySelector("a")?.getAttribute("download") ?? "file",
      },
      filesize: {
        default: "",
        parseHTML: (element) =>
          element.getAttribute("data-filesize") ?? "",
      },
      filetype: {
        default: "",
        parseHTML: (element) =>
          element.getAttribute("data-filetype") ?? "",
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-file-attachment="true"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const src = HTMLAttributes.src as string;
    const filename = HTMLAttributes.filename as string;
    const filesize = HTMLAttributes.filesize as string;
    const filetype = HTMLAttributes.filetype as string;

    const label = filesize ? `${filename} (${filesize})` : filename;

    return [
      "div",
      mergeAttributes(
        {
          "data-file-attachment": "true",
          "data-filesize": filesize,
          "data-filetype": filetype,
          class: "file-attachment",
        },
        // Exclude node-specific attrs from the wrapper element
        {
          ...HTMLAttributes,
          src: undefined,
          filename: undefined,
          filesize: undefined,
          filetype: undefined,
        },
      ),
      [
        "a",
        {
          href: src,
          download: filename,
          target: "_blank",
          rel: "noopener noreferrer",
        },
        label,
      ],
    ];
  },

  addCommands() {
    return {
      setFileAttachment:
        ({ src, filename, filesize, filetype }) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: { src, filename, filesize, filetype },
          });
        },
    };
  },
});
